import { makeStyles, tokens } from '@fluentui/react-components';

/**
 * Every screen's frame, in one place (Christian's walk of deploy #20: G/L Mappings filled ~60% of the screen). Each
 * page carried its own `maxWidth` (900, 1100 or 1200px) and its own title size, so the content area stopped short of
 * the screen and the screens disagreed with each other. The frame now takes the content area's full width, and the
 * title, subtitle and spacing are the same on every page. `src/pages/pageFrame.test.ts` holds both.
 */
export const usePageStyles = makeStyles({
  page: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalL,
    width: '100%',
    minWidth: 0,
  },
  header: { display: 'flex', flexDirection: 'column', gap: tokens.spacingVerticalXS },
  title: {
    fontSize: tokens.fontSizeHero700,
    lineHeight: tokens.lineHeightHero700,
    fontWeight: tokens.fontWeightSemibold,
  },
  subtitle: { color: tokens.colorNeutralForeground3, fontSize: tokens.fontSizeBase300 },
});
